module.exports = __webpack_public_path__ + "static/mp-card-5ddeeedab066e97a5ab91e131b87ada2.png";